angular.module('tgaAdmin')
  .service('scormService', ['$http', 'envService', 'domainService', 'authService',
    function ($http, envService, domainService, authService) {
      const serverAddress = envService.read('serverAddress');

      function getScormUrl(gameId, version) {
        // eslint-disable-next-line max-len
        return `${serverAddress}game/scorm/${gameId}/?X-TGA-KEY=${authService.getAuthentication().token}&domain=${domainService.domain}&version=${version}`;
      }

      function upload(d) {
        let url = `${serverAddress}scorm`;
        if (d.package_type === 'xapi') {
          url = `${serverAddress}xapi`;
        }
        return $http({
          method: 'POST',
          url,
          // IMPORTANT!!! You might think this should be set to 'multipart/form-data'
          // but this is not true because when we are sending up files the request
          // needs to include a 'boundary' parameter which identifies the boundary
          // name between parts in this multi-part request and setting the Content-type
          // manually will not set this boundary parameter. For whatever reason,
          // setting the Content-type to 'undefined' will force the request to automatically
          // populate the headers properly including the boundary parameter.
          headers: { 'Content-Type': undefined },
          data: {
            hub_id: d.hub_id,
            name: d.name,
            xapi_endpoint: d.xapi_endpoint,
            xapi_launch_file: d.xapi_launch_file,
            xapi_auth: d.xapi_auth,
            files: d.files,
            update_game: d.update_game,
          },
          // This method will allow us to change how the data is sent up to the server
          // for which we'll need to encapsulate the params data in 'FormData'
          transformRequest(data) {
            const formData = new FormData();
            formData.append('hub_id', data.hub_id);
            formData.append('name', data.name);
            if (data.xapi_endpoint) {
              formData.append('xapi_endpoint', data.xapi_endpoint);
            }
            if (data.xapi_launch_file) {
              formData.append('xapi_launch_file', data.xapi_launch_file);
            }
            if (data.xapi_auth) {
              formData.append('xapi_auth', data.xapi_auth);
            }
            if (data.update_game) {
              formData.append('update_game', data.update_game);
            }
            // now add all of the assigned files
            for (let i = 0; i < data.files.length; i++) {
              // add each file to the form data
              formData.append('file', data.files[i]);
            }
            return formData;
          },
        }).then(
          (response) => response.data,
          (error) => {
            throw error.data;
          },
        );
      }

      return ({
        getScormUrl,
        upload,
      });
    }]);
